<template>
  <div class="smy__card-full-box page-org">
    <Card
      class="smy__card-full"
      :bordered="false"
      >
      <p slot="title">
        模板审核
      </p>
      <p slot="extra" class="extra">
      </p>
      <div class="top">
        <div class="top-left">
          <ButtonGroup>
            <Button type="primary"
              v-for="(item, index) in templateType"
              :key="item.value"
              :type="searchForm.type == item.value  ? 'primary' : 'ghost'"
              @click="searchForm.type = item.value"
            >{{item.name}}</Button>
          </ButtonGroup>
        </div>
      </div>
      <div class="table">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
          @on-selection-change="selection = $event"
        />
      </div>
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
        style="margin-left:17px;"
      />
    </Card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { templateType } from '@/assets/globalData'

export default {
  data () {
    return {
      templateType,
      // typeNameList: ['应用模板', '回执模板', '评价模板', '回访模板'],
      searchForm: {
        auditState: 0,
        type: 1
      },
      pageSize: 10,
      pageIndex: 0,
      listLoading: false,
      edit: 1,
      count: 0,
      list: []
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 250,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let passBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '审核',
                    content: '确认审核通过吗？',
                    onOk: () => {
                      this.$http.put('/templateExamine/examine', {
                        id: row.id,
                        auditState: 1
                      }).then(res => {
                        if (res.success) {
                          this.$Message.success('审核成功')
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    }
                  })
                }
              }
            }, ['审核通过'])
            let failBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              style: {
                marginRight: '10px'
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '审核',
                    content: '确认审核驳回吗？',
                    onOk: () => {
                      this.$http.put('/templateExamine/examine', {
                        id: row.id,
                        auditState: 2
                      }).then(res => {
                        if (res.success) {
                          this.$Message.success('审核成功')
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    }
                  })
                }
              }
            }, ['审核驳回'])
            let detailBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'TempleMarketDetail', params: { id: row.id } })
                }
              }
            }, ['查看详情'])
            return h('span', [
              passBtn,
              failBtn,
              detailBtn
            ])
          }
        },
        {
          title: '模板名称',
          key: 'name',
          width: 160
        },
        {
          title: '行业标签',
          key: 'industryName',
          width: 100
        },
        {
          title: '上传者',
          key: 'enterpriseName',
          width: 260
        },
        {
          title: '上传时间',
          key: 'createtime',
          width: 160
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  watch: {
    'searchForm.type': {
      handler (val) {
        this.loadList()
      }
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      let params = {
        ...this.searchForm,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      this.$http.all([
        this.$http.get('/templateExamine/list', {
          params
        }),
        this.$http.get('/templateExamine/count', {
          params
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = (pageIndex - 1)
      this.loadList()
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.page {
  margin: 16px 0;
}

.table {
  margin-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/templeManage/templeMarket/index.vue